var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { useHTTPProviders } from './hooks';
import { Codeblock } from './Codeblock';
import { CDN_AUTOLOAD_PATH } from '@codeblock/core/lib/http';
import cdnThemeProvider from '@codeblock/themes/lib/cdn';
export var CodeblockCDN = function CodeblockCDN(_a) {
  var _a$prismPath = _a.prismPath,
      prismPath = _a$prismPath === void 0 ? CDN_AUTOLOAD_PATH : _a$prismPath,
      props = __rest(_a, ["prismPath"]);

  var cdnProviders = useHTTPProviders(prismPath, cdnThemeProvider);
  return React.createElement(Codeblock, Object.assign({
    providers: cdnProviders
  }, props));
};
export default CodeblockCDN;